/*$(window).on('load', function () {
  $("#js-loader").fadeOut(3000); // これだけでOK
});*/
$(window).scroll(function () {
  $('.fadein').each(function () {
    var elemPos = $(this).offset().top,
      scroll = $(window).scrollTop(),
      windowHeight = $(window).height();

    if (scroll > elemPos - windowHeight + 150) {
      $(this).addClass('scrollin');
    }
  });
});
$(function () {
  $('.fv_fade').addClass('scrollin');
})